import React, { createContext, useContext } from 'react';
import useTheme from '../hooks/useTheme.js';

// Create Theme Context with a default value
const ThemeContext = createContext({
  currentTheme: null,
  switchTheme: () => {},
  isLoading: true,
  error: null
});

// Theme Provider Component
export function ThemeProvider({ children }) {
  const themeValue = useTheme();
  
  return (
    <ThemeContext.Provider value={themeValue}>
      {children}
    </ThemeContext.Provider>
  );
}

// Hook to use theme context
export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
